export default __webpack_public_path__ + "static/media/m_ai_bg.08eb02ea.png";